import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {routerNavigatedAction} from '@ngrx/router-store';
import {catchError, filter, map, mergeMap, switchMap, tap, withLatestFrom} from 'rxjs/operators';
import {getDashboardPath} from '../state/router/router.selectors';
import {payload} from '../state/payload';
import {of} from 'rxjs';
import {reportError} from '../state/errors/errors.actions';
import {
  fetchSchooldashboardOnderwijssoortDetails,
  fetchSchooldashboardVakDetails,
  setBazenbanner, setSchooldashboardOnderwijssoortDetails,
  setSchooldashboardOnderwijssoorten, setSchooldashboardVakDetails,
  setSchooldashboardVakken
} from '../state/schooldashboard/schooldashboard.actions';
import {DashboardingService} from '../services/dashboarding.service';
import {DashboardsettingsFacade} from '../state/dashboardsettings/dashboardsettings.facade';
import {SchooldashboardNewFacade} from '../state/schooldashboard/schooldashboard.facade';
import {dashboardSettingsLoaded} from '../state/dashboardsettings/dashboardsettings.actions';
import {Router} from '@angular/router';

@Injectable()
export class SchooldashboardVakkenEffect {
  $ = createEffect(() => this.actions$.pipe(
    ofType(routerNavigatedAction, dashboardSettingsLoaded),
    filter(_ => getDashboardPath(this.router.url) === '/schooldashboardnew'),
    withLatestFrom(this.settings.isGegroepeerdOpVak(), this.schooldashboard.hasVakken(), this.settings.areSettingsLoaded()),
    filter(([_, isGegroepeerdOpVak, hasVakken, settingsLoaded]) => isGegroepeerdOpVak && !hasVakken && settingsLoaded),
    withLatestFrom(this.settings.getBegindatumForBackend(), this.settings.getPeriodeOrDefault(), this.settings.getVestigingUUID()),
    switchMap(([_, begindatum, periode, vestigingUUID]) => this.dashboardingService.fetchSchooldashboardVakken(begindatum, periode, vestigingUUID)),
    map(payload),
    map(setSchooldashboardVakken),
    catchError(err => of(err).pipe(map(e => reportError(payload(e)))))
  ));

  constructor(private actions$: Actions, private router: Router, private dashboardingService: DashboardingService, private schooldashboard: SchooldashboardNewFacade, private settings: DashboardsettingsFacade) {
  }
}

@Injectable()
export class SchooldashboardVakDetailsEffect {
  $ = createEffect(() => this.actions$.pipe(
    ofType(fetchSchooldashboardVakDetails),
    filter(action => action?.value?.naam !== null && action?.value?.naam !== undefined),
    withLatestFrom(this.settings.getBegindatumForBackend(), this.settings.getPeriodeOrDefault(), this.settings.getVestigingUUID()),
    mergeMap(([action, begindatum, periode, vestigingUUID]) => this.dashboardingService.fetchSchooldashboardVakDetails(begindatum, periode, vestigingUUID, action.value.naam)
      .pipe(
        map(vakdetails => ({vakdetails, naam: action.value.naam})),
      )),
    map(setSchooldashboardVakDetails),
    catchError(err => of(err).pipe(map(e => reportError(payload(e)))))
  ));

  constructor(private actions$: Actions, private dashboardingService: DashboardingService, private settings: DashboardsettingsFacade) {
  }
}

@Injectable()
export class SchooldashboardOnderwijssoortenEffect {
  $ = createEffect(() => this.actions$.pipe(
    ofType(routerNavigatedAction, dashboardSettingsLoaded),
    filter(_ => getDashboardPath(this.router.url) === '/schooldashboardnew'),
    withLatestFrom(this.settings.isGegroepeerdOpOnderwijssoort(), this.schooldashboard.hasOnderwijssoorten(), this.settings.areSettingsLoaded()),
    filter(([_, isGegroepeerdOpOnderwijssoort, hasOnderwijssoorten, settingsLoaded]) => isGegroepeerdOpOnderwijssoort && !hasOnderwijssoorten && settingsLoaded),
    withLatestFrom(this.settings.getBegindatumForBackend(), this.settings.getPeriodeOrDefault(), this.settings.getVestigingUUID()),
    switchMap(([_, begindatum, periode, vestigingUUID]) => this.dashboardingService.fetchSchooldashboardOnderwijssoorten(begindatum, periode, vestigingUUID)),
    map(payload),
    map(setSchooldashboardOnderwijssoorten),
    catchError(err => of(err).pipe(map(e => reportError(payload(e)))))
  ));

  constructor(private actions$: Actions, private router: Router, private dashboardingService: DashboardingService, private schooldashboard: SchooldashboardNewFacade, private settings: DashboardsettingsFacade) {
  }
}

@Injectable()
export class SchooldashboardOnderwijssoortDetailsEffect {
  $ = createEffect(() => this.actions$.pipe(
    ofType(fetchSchooldashboardOnderwijssoortDetails),
    filter(action => action?.value?.naam !== null && action?.value?.naam !== undefined),
    withLatestFrom(this.settings.getBegindatumForBackend(), this.settings.getPeriodeOrDefault(), this.settings.getVestigingUUID()),
    mergeMap(([action, begindatum, periode, vestigingUUID]) => this.dashboardingService.fetchSchooldashboardOnderwijssoortDetails(begindatum, periode, vestigingUUID, action.value.naam)
      .pipe(
        map(onderwijssoortdetails => ({onderwijssoortdetails, naam: action.value.naam})),
      )),
    map(setSchooldashboardOnderwijssoortDetails),
    catchError(err => of(err).pipe(map(e => reportError(payload(e)))))
  ));

  constructor(private actions$: Actions, private dashboardingService: DashboardingService, private settings: DashboardsettingsFacade) {
  }
}

@Injectable()
export class BazenbannerEffect {
  $ = createEffect(() => this.actions$.pipe(
    ofType(routerNavigatedAction, dashboardSettingsLoaded),
    filter(_ => getDashboardPath(this.router.url) === '/schooldashboardnew'),
    withLatestFrom(this.schooldashboard.hasBazenbanner(), this.settings.areSettingsLoaded()),
    filter(([_, hasBazenbanner, areSettingsLoaded]) => !hasBazenbanner && areSettingsLoaded),
    withLatestFrom(this.settings.getBegindatumForBackend(), this.settings.getPeriodeOrDefault(), this.settings.getVestigingUUID()),
    switchMap(([_, begindatum, periode, vestigingUUID]) => this.dashboardingService.fetchBazenbanner(begindatum, periode, vestigingUUID)),
    map(payload),
    map(setBazenbanner),
    catchError(err => of(err).pipe(map(e => reportError(payload(e)))))
  ));

  constructor(private actions$: Actions, private router: Router, private dashboardingService: DashboardingService, private schooldashboard: SchooldashboardNewFacade, private settings: DashboardsettingsFacade) {
  }
}
